export function divideNumberIntoClasses(num) {
    if (!num) return "";
    const trimmed = num.toString().trim();
    if (!trimmed) return "";

    const number = `${trimmed} `;
    const parts = number.split(".");
    let entier = parts[0];

    entier = parseFloat(entier.replace(/\s/g, ""));
    if (!entier) return num;

    entier = entier
        .toString()
        .trim()
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ");

    parts[0] = entier;
    const result = parts.join(".").trim();

    return result;
}
